import router from "@/router/index";

export default function(e) {
  if (e.response && e.response.status && e.response.status === 404) {
    // router.push("/404");
    router;
  }
}
